/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

import React from 'react';
import PropTypes from 'prop-types';
import sanitizeIds from '../Utilities/id/sanitizeIds.js';
import { useTranslation } from '../Utilities/i18n/i18n.js';

var EmptyDarkState = function EmptyDarkState(_ref) {
  var id = _ref.id,
    ariaLabelProp = _ref.ariaLabel;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var ariaLabel = ariaLabelProp || t('Empty state icon');
  var uniqueId = id || Math.floor(1000 + Math.random() * 9000);
  var gradientIds = sanitizeIds(['icon--emptystate--linear-gradient', 'icon--emptystate--linear-gradient-2', 'icon--emptystate--linear-gradient-3'], uniqueId);
  return /*#__PURE__*/React.createElement("svg", {
    "aria-label": ariaLabel,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['icon--emptystate--linear-gradient'],
    x1: "11.12",
    x2: "40",
    y1: "43.34",
    y2: "43.34",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#393939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#262626"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['icon--emptystate--linear-gradient-2'],
    x1: "40",
    x2: "68.88",
    y1: "43.34",
    y2: "43.34",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#161616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#262626"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['icon--emptystate--linear-gradient-3'],
    x1: "32.78",
    x2: "47.22",
    y1: "30.83",
    y2: "5.83",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#525252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#393939"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M40 78.34L11.13 61.67 40 45.01l28.86 16.66L40 78.34z",
    opacity: ".25"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#".concat(gradientIds['icon--emptystate--linear-gradient'])
    },
    d: "M40 68.35L11.12 51.68l.01-33.35L40 34.99v33.36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#".concat(gradientIds['icon--emptystate--linear-gradient-2'])
    },
    d: "M68.88 51.68L40 68.35V35l28.87-16.67v33.35z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#".concat(gradientIds['icon--emptystate--linear-gradient-3'])
    },
    d: "M40 35L11.13 18.32 40 1.66l28.87 16.67L40 34.99z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#262626",
    d: "M25.97 26.67l28.67-16.55-.42-.24-28.68 16.56.43.23z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6f6f6f",
    d: "M40 35.24L11.13 18.57v-.24l.21-.12 28.87 16.66L40 35v.24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#525252",
    d: "M21.5 33.33l-8.2-4.73v-5.69l8.2 4.74v5.68z"
  }));
};
EmptyDarkState.propTypes = {
  id: PropTypes.string,
  ariaLabel: PropTypes.string
};
var EmptyDark = EmptyDarkState;

export { EmptyDark as default };
